module.exports = __webpack_public_path__ + "img/ctt_azul.e24a92b5.png";